module.exports = __webpack_public_path__ + "static/assets/3b4d242f6517e1bb53edfbc5ec81afc9.ttf";